<template>
  <!-- LOADING -->
  <v-btn
    v-if="loading && currentIndex === -1"
    class="mr-3"
    density="compact"
    icon
    loading
    variant="flat"
  />

  <!-- PREV/NEXT -->
  <div
    v-else-if="currentIndex >= 0"
    class="d-flex flex-row align-center ga-2 mr-3"
  >
    <div>
      <v-btn
        v-if="currentIndex >= 1"
        density="compact"
        exact
        icon="far fa-chevron-left"
        :to="previousTo"
        variant="flat"
        @click="onPrevious"
      />
    </div>

    <div v-if="currentIndex === -1">
      <v-progress-circular indeterminate size="16" />
    </div>
    <div v-else class="text-no-wrap">
      {{
        t('navigation.of', {
          currentFile: displayIndex + 1,
          filesNumber: total,
        })
      }}
    </div>

    <div>
      <v-btn
        v-if="currentIndex < total - 1"
        density="compact"
        exact
        icon="far fa-chevron-right"
        :loading="loadingNext"
        :to="nextTo"
        variant="flat"
        @click="onNext"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router'

const props = withDefaults(
  defineProps<{
    currentIndex: number
    displayIndex: number
    total: number
    loading?: boolean
    loadingNext?: boolean
    previousTo?: RouteLocationRaw
    nextTo?: RouteLocationRaw
  }>(),
  {
    loading: false,
    loadingNext: false,
    previousTo: undefined,
    nextTo: undefined,
  },
)

const emit = defineEmits<{
  previous: []
  next: []
}>()

const { t } = useI18n()

function onPrevious() {
  if (props.previousTo) {
    return
  }
  emit('previous')
}

function onNext() {
  if (props.nextTo) {
    return
  }
  emit('next')
}
</script>
